import { useGlobalModal } from '@/hooks/useGlobalModal';
import GlobalModal from '@components/GlobalModal';
import { Access } from '@features/authorization';
import { type FC } from 'react';
import { CreateDeviceForm } from './form';
import { Trans } from '@lingui/macro';

export const CreateDeviceModal: FC = () => {
  const { globalModalProps, onClose } = useGlobalModal('createDeviceModal');

  return (
    <GlobalModal
      {...globalModalProps}
      dialogProps={{ maxWidth: 'sm' }}
      authorization={{
        access: Access.CreateDevice,
        onClose,
      }}
      modalTitleProps={{
        title: <Trans>Crear nuevo dispositivo</Trans>,
        onClose,
      }}
    >
      <CreateDeviceForm onClose={onClose} />
    </GlobalModal>
  );
};
